import React from "react";
import "./Agenga.css";
import Wordglobe from "../Wordglobe/Wordglobe";


const Agenda= () => {
  const d = new Date().getTime();
  console.log(d);
  return (
    <section id="agenda">
    <div className="astitvaa__section2" id="agenda">
      <div className="astitvaa__section2-body">
        <div className="astitvaa__section2-title">
          About 
          <img src='https://th.bing.com/th/id/R.ed6620f65408446280a4d7981cecf56f?rik=9AkNCtI3NgpkWw&riu=http%3a%2f%2fmedia.giphy.com%2fmedia%2fhE7qzzcOwXh5u%2fgiphy.gif&ehk=GsIgDb%2b5agex2GX5n9%2f8NkA32U6roLqG3Jvvwjdb%2fWw%3d&risl=&pid=ImgRaw&r=0' alt='ad'></img> 
        </div>
        <div className="astitvaa__section2-menu">
          <div className="astitvaa__section2-wordglobe">
            <Wordglobe></Wordglobe>
            </div>
          <div className="astitvaa__section2-content">
            <span style={{ color: "var(--secondary-c)" }}>Astitva</span>{" "}
            This grand celebration will showcase the prowess of five distinctive
clubs, each a pillar in shaping the dynamic tapestry of our student
body. From the eloquent debates of Rhetorical Cosmos to the
cutting-edge innovations of the Developers Club, the rhythmic
beats of Cultural Club, the futuristic creations of the Robotics and
IoT Club, and the adrenaline-pumping events of the Sports Club,
ASTITVA promises an immersive experience that transcends the
ordinar
          </div>
          
        </div>
      </div>
    </div>
    </section>
  );
};

export default Agenda;
